var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('b-input',{attrs:{"value":_vm.value.value},on:{"input":function($event){return _vm.setValue($event, 'value')}}}),_vm._v(" "),_c('b-select',{attrs:{"value":_vm.value.unit,"options":_vm.options},on:{"input":function($event){return _vm.setValue($event, 'unit')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }